var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container-one"},[_c('div',{staticClass:"text-content"},[_c('div',{staticClass:"text-two"},[_vm._v("抱歉，您访问的页面出错啦")]),_vm._v(" "),_c('div',{staticClass:"text-one"},[_vm._v("建议你去别处看看...")]),_vm._v(" "),_c('div',{staticClass:"button",on:{"click":function($event){return _vm.back()}}},[_vm._v("去首页")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17515ab0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/error.vue
// module id = null
// module chunks = 